import { FormControl, Select, MenuItem, Box, Paper, Typography } from '@mui/material';
import { AppContext } from '../../../RoutesWithAuth';
import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from "@mui/styles";
import axios from '../../common/AxiosConfig';
import { RequestorMapping } from '../../common/commons';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px',
    },
    headerBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#708090',
        padding: '10px 16px',
        color: '#fff',
    },
    headerTitle: {
        fontWeight: 600,
        fontSize: '1rem',
        letterSpacing: '0.3px',
    },
    filterRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    filterLabel: {
        fontWeight: 500,
        fontSize: '1rem',
        color: '#fff',
    },
    selectControl: {
        minWidth: 150,
        '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
            backgroundColor: 'rgba(255,255,255,0.95)',
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#fff',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#fff',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
        },
        '& .MuiSelect-select': {
            // padding: '6px 12px',
            fontSize: '0.8rem',
        },
    },
    cardsContainer: {
        padding: '20px 16px 16px 16px',
        backgroundColor: '#f8fafc',
    },
    cardsGrid: {
        gap: '16px',
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        justifyItems: 'stretch',
        alignItems: 'center',
    },
    card: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px 12px 16px 12px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        border: '1px solid #d0d7de',
        transition: 'all 0.2s ease',
        cursor: 'default',
        marginTop: '8px',
        height: '5rem',
        '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            transform: 'translateY(-2px)',
            borderColor: '#267db7',
        },
    },
    cardTotal: {
        backgroundColor: '#5a8db0',
        border: '1px solid #206695',
        '& $cardValue': {
            color: '#fff',
        },
        '& $cardLabel': {
            color: '#fff',
            backgroundColor: '#1e5f8a',
        },
        '&:hover': {
            backgroundColor: '#1e6a9e',
            boxShadow: '0 4px 12px rgba(38,125,183,0.3)',
        },
    },
    cardValue: {
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#267db7',
        lineHeight: 1.2,
        marginTop: '10px',
    },
    cardLabel: {
        position: 'absolute',
        top: '-10px',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '0.8rem',
        color: '#ffffff',
        fontWeight: 600,
        backgroundColor: '#206695',
        padding: '4px 8px 2px 8px',
        borderRadius: '8px',
        whiteSpace: 'nowrap',
        border: '1px solid #d0d7de',
    },
    menuItem: {
        fontSize: '0.85rem',
        padding: '8px 16px',
        '&:hover': {
            backgroundColor: '#f0f7ff',
        },
        '&.Mui-selected': {
            backgroundColor: '#e3f2fd',
            '&:hover': {
                backgroundColor: '#d0e8fc',
            },
        },
    },
});


function RequestsCount() {
    const classes = useStyles();
    const [requestHealth, setRequestHealth] = useState();
    const [requestor, setRequestor] = useState("All");
    const context = useContext(AppContext);
    const authToken = context.authToken.get;

    useEffect(() => {
        if (authToken) {
            axios.get("reports/request_health", {
                headers: {
                    Authorization: authToken
                },
                params: {
                    requestor
                }
            }).then(res => {
                setRequestHealth(res.data);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestor, authToken]);

    const updateFormData = (value) => {
        setRequestor(value);
    };

    const requestorCountFields = [
        { name: "Total", field: 'total_count', isTotal: true },
        { name: "AWL", field: 'awl' },
        { name: "DA", field: 'da' },
        { name: "ISR", field: 'isr' },
        { name: "RTC", field: 'rtc' },
        { name: "RTD", field: 'rtd' },
        { name: "RTK", field: 'rtk' },
        { name: "RTO", field: 'rtoo' },
        { name: "RTT", field: 'rtt' },
        { name: "RWL", field: 'rwl' },
        { name: "TVLA", field: 'tvla' },
        { name: "UFV", field: 'ufv' }
    ];

    // Compute total by summing individual counts instead of using backend's total_count
    const computedTotal = requestHealth
        ? requestorCountFields
            .filter(f => !f.isTotal)
            .reduce((sum, f) => sum + (Number(requestHealth[f.field]) || 0), 0)
        : null;

    const requestorList = [
        "All",
        RequestorMapping.B2B,
        RequestorMapping.CUSTOMER,
        RequestorMapping.DRIVER,
        RequestorMapping.EMPLOYEE,
        RequestorMapping.SURVIVOR,
        RequestorMapping.TCICUSTOMER
    ];

    return (
        <Box>
            {/* Header with filter */}
            <Box className={classes.headerBar}>
                <Typography className={classes.headerTitle}>Requests in Progress</Typography>
                <Box className={classes.filterRow}>
                    <Typography className={classes.filterLabel}>Filter by Requestor:</Typography>
                    <FormControl className={classes.selectControl} size="small">
                        <Select
                            id="requestor"
                            value={requestor}
                            onChange={(e) => updateFormData(e.target.value)}
                            displayEmpty
                        >
                            {requestorList.map((name) => (
                                <MenuItem key={name} value={name} className={classes.menuItem}>
                                    {name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            {/* Cards */}
            <Box className={classes.cardsContainer}>
                <Box className={classes.cardsGrid}>
                    {requestorCountFields.map(({ name, field, isTotal }) => (
                        <Paper
                            key={field}
                            className={`${classes.card} ${isTotal ? classes.cardTotal : ''}`}
                            elevation={0}
                        >
                            <Typography className={classes.cardLabel}>
                                {name}
                            </Typography>
                            <Typography className={classes.cardValue} data-testid={`value-${field}`}>
                                {isTotal
                                    ? (computedTotal !== null ? computedTotal : '--')
                                    : (requestHealth?.[field] ?? '--')}
                            </Typography>
                        </Paper>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default RequestsCount;